/* File Constant Module */

/** @description 5MB*/
export const FILE_LIMIT = 5242880;
